import React from 'react'
import PropTypes from 'prop-types'
import { midas } from '@resurs/midas'
import { getText } from '../../../internal/TextLabels'

const buttonStyle = {
  background: '#fff',
  borderBottom: 'none',
  borderTop: 'none',
  borderRight: 'none',
  borderLeft: '1px solid #dcddde',
  padding: '1.2rem 2rem',
  margin: '-.4rem 0',
}

const Pagination = ({ page, onRowsPerPageChange, onNext, onPrev }) => (
  <div
    style={{
      display: 'flex',
      alignItems: 'center',
      userSelect: 'none',
    }}
  >
    <div style={{ padding: '.8rem', display: 'flex', alignItems: 'center' }}>
      <span
        style={{
          whiteSpace: 'nowrap',
          fontSize: '1.1rem',
          padding: '0 1rem 0 0',
        }}
      >
        {getText('default.table.pageSize')}
      </span>
      <select
        id="table-actions"
        className={[midas.formSelect, midas.selectSm].join(' ')}
        style={{ lineHeight: 1.15 }}
        value={page.size}
        onChange={e => onRowsPerPageChange(e.target.value)}
      >
        {[5, 10, 20, 50].map(item => (
          <option key={item} value={item}>
            {item}
          </option>
        ))}
      </select>
    </div>
    <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center' }}>
      <span
        style={{
          padding: '0 1rem',
          color: '#999',
          ...((page.number == null && { display: 'none' }) || {}),
        }}
      >
        {page.number + 1}
        {' / '}
        {page.totalPages}
      </span>
      <button
        type="button"
        className={midas.hand}
        style={buttonStyle}
        onClick={onPrev}
        disabled={page.number == null || page.number === 0}
      >
        <svg fillRule="evenodd" height={12} width={8} viewBox="0 0 8 12">
          <path d="M7.5 10.6L2.8 6l4.7-4.6L6.1 0 0 6l6.1 6z" />
        </svg>
      </button>
      <button
        type="button"
        className={midas.hand}
        style={buttonStyle}
        onClick={onNext}
        disabled={page.number == null || page.totalPages - page.number <= 1}
      >
        <svg fillRule="evenodd" height={12} width={8} viewBox="0 0 8 12">
          <path d="M0 10.6L4.7 6 0 1.4 1.4 0l6.1 6-6.1 6z" />
        </svg>
      </button>
    </div>
  </div>
)

Pagination.propTypes = {
  page: PropTypes.object.isRequired,
  onRowsPerPageChange: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
  onPrev: PropTypes.func.isRequired,
}

export default Pagination
